import React from 'react';

import placeHolder from '@assets/images/loading-header.png';
import Image from './Image';

function FallbackImage(props) {
  return <Image src={placeHolder} {...props} />;
}

export default FallbackImage;
